import React from 'react';
import { useUrlState } from '../../hooks/useUrlState';
import ProjectConversationsTab from './ProjectConversationsTab';
import ProjectOutreachSummary from './ProjectOutreachSummary';

export default function ProjectVendorsTab({ projectId, threads, loading, onCount }) {
    const [view, setView] = useUrlState('vendorView', 'outreach');
    return <>
        <div className="po-view-switch" role="group" aria-label="Vendor views">
            <button type="button" className="gts-btn btn-small" aria-pressed={view !== 'conversations'} onClick={() => setView('outreach')}>Outreach</button>
            <button type="button" className="gts-btn btn-small" aria-label="Vendor conversations" aria-pressed={view === 'conversations'} onClick={() => setView('conversations')}>Conversations{threads.length ? ` (${threads.length})` : ''}</button>
        </div>
        {view === 'conversations' ? <ProjectConversationsTab threads={threads} variant="vendor" loading={loading} /> : <ProjectOutreachSummary key={projectId} projectId={projectId} onCount={onCount} />}
    </>;
}
